import { type AdminFlag } from '@libraries/typescript/api_client';

export const ORCHESTRATOR_PRODUCT_CHAT_FLAG_NAME =
    'ORCHESTRATOR_PRODUCT_CHAT_ENABLED';

export function readFlagBoolean(flag: AdminFlag | undefined): boolean {
    if (!flag) {
        return false;
    }
    const value = flag.current_value ?? flag.default_value;
    return value === true;
}
